module.exports = __webpack_public_path__ + "static/img/1_v2.abeb92f2.png";